
const spellConfig = {
    ///模板
    template: {
        ///基本设置
        basic: {
            ///自动播放次数
            autoPlay: "1",
            ///完成等待确认
            finishWaitConfirm:"1",
            ///音标显示
            symbolVisible: "show",
            ///切换方式
            loopMode:"order"
        },
        ///音效设置
        soundEffect:{
            ///键盘音效
            keyboard:"keyboard1.mp3",
            ///错误音效
            error:"error.wav",
            ///正确音效
            correct:"correct.wav"
        },
        font:{
            ///译文字体大小
            translateSize:35,
            ///音标字体大小
            symbolSize:25,
            ///原文字体大小
            textSize:45,
        }
    },
    config: null,
    ///获取配置文件
    getConfig: function () {
        if (this.config != null) {
            return this.config;
        }
        var item = localStorage.getItem("comekey_spell_learnc_onfig")
        if (item != null && item != "") {
            this.config = JSON.parse(item);
            ///检查配置升级
            this.checkUpdateConfig()
        } else {
            ///如果没有配置文件，则使用默认配置
            this.config = JSON.parse(JSON.stringify(this.template));
        }
        return this.config;
    },
    ///检查更新配置
    checkUpdateConfig: function () {
        for (var key in this.template) {
            if (typeof (this.config[key]) == "undefined") {
                console.log("缺少配置项=" + key)
                this.config[key] = this.template[key]
                continue
            }
            var subItem = this.template[key]
            if (typeof subItem === 'object') {
                for (var subkey in subItem) {
                    if (typeof (this.config[key][subkey]) == "undefined") {
                        this.config[key][subkey] = subItem[subkey]
                    }
                }
            }

        }
    },
    ///保存配置文件
    saveConfig: function () {
        if (this.config != null) {
            localStorage.setItem("comekey_spell_learnc_onfig", JSON.stringify(this.config));
        }
    }
}

export default spellConfig